import React from 'react'
import { Typography } from '@mui/material'

const UiTextHeadlineLargeBold = ({ text, sx, ...props }) => {
  return (
    <Typography
      sx={{
        fontFamily: '"Roboto", sans-serif',
        fontWeight: 700,
        fontSize: '32px',
        lineHeight: '40px',
        letterSpacing: 0,
        ...sx,
      }}
      {...props}
    >
      {text}
    </Typography>
  )
}

export default UiTextHeadlineLargeBold
